export default __webpack_public_path__ + "static/media/hotmama.91261cf4.png";